var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating"},[_c('h2',[_vm._v("Ready To Build Your Community?")]),_c('div',{staticClass:"btn-div"},[_c('my-button',{staticClass:"btn"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }